import { Navigate, useLocation } from 'react-router-dom'

/**
 * Redirect que PRESERVA a query string.
 *
 * ⚠️ `<Navigate to="/x">` DESCARTA `?...`, e isso transforma o motivo de um
 * redirect existir na coisa que ele quebra: o argumento escrito ao lado de
 * cada rota antiga de Compras é "favorito e link salvo existem, e quebrá-los é
 * custo sem ganho" — mas um favorito `/compras/ordens-compra?oc=<id>` chegava
 * em `/compras` SEM o detalhe da ordem. Achado da revisão independente
 * (08/10/2026).
 *
 * Quando o destino tem query própria (`/compras/configuracoes?aba=familias`),
 * ELA GANHA: o `aba` do destino é a razão do redirect, e um `?aba=` velho no
 * link antigo não pode sobrescrevê-lo.
 */
export function RedirectComQuery({ para }: { para: string }) {
  const { search } = useLocation()
  if (!search) return <Navigate to={para} replace />

  const [caminho, queryDoDestino] = para.split('?')
  const alvo = new URLSearchParams(queryDoDestino)
  for (const [chave, valor] of new URLSearchParams(search)) {
    if (!alvo.has(chave)) alvo.set(chave, valor)
  }
  return <Navigate to={`${caminho}?${alvo.toString()}`} replace />
}
